import RichText from '@commons/components/RichText';
import type { DrupalBlock, DrupalText } from '@commons/types/drupal';

/**
 * Page description field block component.
 */

const PageDescriptionFieldBlock = ({ content }: DrupalBlock<DrupalText>) => {
  if (!content?.value) return null;

  return <RichText width={12} value={content.value} />;
};

export default PageDescriptionFieldBlock;
